import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, from, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { SendMailRequest, SendMailResponse } from '../models/send-mail.model';
import { CipherService } from '../core/services/cipher.service';

@Injectable({
  providedIn: 'root'
})
export class MailService {
  private sendMailUrl =
    (environment as { sendMailApiUrl?: string }).sendMailApiUrl
    ?? `${environment.apiBaseUrl}/api/mail/enviar`;

  constructor(
    private http: HttpClient,
    private cipher: CipherService
  ) {}

  enviar(request: SendMailRequest): Observable<SendMailResponse> {
    return this.postEncrypted<SendMailResponse>(this.sendMailUrl, request);
  }

  private postEncrypted<T>(url: string, body: unknown): Observable<T> {
    if (!this.cipher.isEncryptionEnabled) {
      return this.http.post<T>(url, body);
    }

    return from(this.cipher.encrypt(JSON.stringify(body))).pipe(
      switchMap((encrypted) =>
        this.http.post<{ data?: string } | T>(url, { data: encrypted })
      ),
      switchMap((response) => this.unwrapCipherResponse<T>(response))
    );
  }

  private unwrapCipherResponse<T>(response: { data?: string } | T): Observable<T> {
    const wrapped = response as { data?: unknown };
    if (wrapped?.data && typeof wrapped.data === 'string') {
      return from(this.cipher.decrypt(wrapped.data)).pipe(
        map((plain) => JSON.parse(plain) as T)
      );
    }
    return of(response as T);
  }
}
